var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsPreviewBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 176,
    viewBox: "0 0 262 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H254C258.418 0 262 3.58172 262 8V176H0V8Z",
    fill: "#FCE3C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_203_88",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 262,
    height: 176
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H254C258.418 0 262 3.58172 262 8V176H0V8Z",
    fill: "#F0F0F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_203_88)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M79.394 112.441V175.467C79.3845 181.965 81.0828 188.351 84.3178 193.981C87.5528 199.61 92.2101 204.285 97.8205 207.534L152.271 239.048C157.873 242.292 164.228 244 170.697 244C177.166 244 183.521 242.292 189.123 239.048L243.574 207.534C249.184 204.285 253.841 199.61 257.076 193.981C260.311 188.351 262.01 181.965 262 175.467V112.441C261.993 105.958 260.287 99.5917 257.053 93.9794C253.819 88.3672 249.17 83.7067 243.574 80.4655L189.123 48.9524C183.521 45.708 177.166 44 170.697 44C164.228 44 157.873 45.708 152.271 48.9524L97.8205 80.9276C92.2907 84.1292 87.685 88.7169 84.4548 94.2413C81.2246 99.7656 79.4807 106.037 79.394 112.441Z",
    fill: "#FFB555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00010108 0.440689V63.4669C-0.00944766 69.9649 1.68886 76.3507 4.92385 81.9805C8.15884 87.6104 12.8162 92.2854 18.4265 95.5345L72.8766 127.048C78.479 130.292 84.8341 132 91.3031 132C97.7721 132 104.127 130.292 109.73 127.048L164.18 95.5345C169.79 92.2854 174.447 87.6104 177.682 81.9805C180.917 76.3507 182.616 69.9649 182.606 63.4669V0.440689C182.599 -6.04168 180.893 -12.4083 177.659 -18.0206C174.425 -23.6328 169.776 -28.2933 164.18 -31.5345L109.73 -63.0476C104.127 -66.292 97.7721 -68 91.3031 -68C84.8341 -68 78.479 -66.292 72.8766 -63.0476L18.4265 -31.0724C12.8967 -27.8708 8.29108 -23.2831 5.06088 -17.7587C1.83069 -12.2344 0.0867987 -5.9631 0.00010108 0.440689Z",
    fill: "#FFB555"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.6971 56.4407V119.467C39.6875 125.965 41.3858 132.351 44.6208 137.981C47.8558 143.61 52.5132 148.285 58.1235 151.534L112.574 183.048C118.176 186.292 124.531 188 131 188C137.469 188 143.824 186.292 149.426 183.048L203.877 151.534C209.487 148.285 214.144 143.61 217.379 137.981C220.614 132.351 222.313 125.965 222.303 119.467V56.4407C222.296 49.9583 220.59 43.5917 217.356 37.9794C214.122 32.3672 209.473 27.7067 203.877 24.4655L149.426 -7.04756C143.824 -10.292 137.469 -12 131 -12C124.531 -12 118.176 -10.292 112.574 -7.04756L58.1235 24.9276C52.5937 28.1292 47.988 32.7169 44.7578 38.2413C41.5277 43.7656 39.7838 50.0369 39.6971 56.4407Z",
    fill: "#FFB555"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsPreviewBg);
export default __webpack_public_path__ + "static/media/reports-preview-bg.039c7d61621a29929ce99a228153b0cc.svg";
export { ForwardRef as ReactComponent };